import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
// ng-zorro imports
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DeoAiAssistantScreenComponent } from './deo-ai-assistant-screen/deo-ai-assistant-screen.component';
import { GainsUiCommonsModule } from '@gainsystems/gains-ui-commons';
import { routes } from './deo-ai-assistant.routing';
import { DeoConversationChipsComponent } from './components/deo-conversation-chips/deo-conversation-chips.component';
import { DeoMessageProgressComponent } from './components/deo-message-progress/deo-message-progress.component';
import { DeoTalkingToSelectorComponent } from './components/deo-talking-to-selector/deo-talking-to-selector.component';
import { DeoAgentRunsPanelComponent } from './deo-ai-assistant-screen/deo-agent-runs-panel/deo-agent-runs-panel.component';
import { DeoAiAssistantWidgetComponent } from './deo-ai-assistant-wigdet/deo-ai-assistant-widget.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { GainsSharedModule } from 'app/shared/modules/gains-shared.module';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { DeoAiAssistantChatsViewComponent } from './deo-ai-assistant-screen/deo-ai-assistant-chats-view/deo-ai-assistant-chats-view.component';
import { DeoAiAssistantRenameChatComponent } from './deo-ai-assistant-screen/deo-ai-assistant-rename-chat/deo-ai-assistant-rename-chat.component';
import { DeoAiAssistantMoveToProjectComponent } from './deo-ai-assistant-screen/deo-ai-assistant-move-to-project/deo-ai-assistant-move-to-project.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { DeoCreateNewProjectComponent } from './deo-ai-assistant-screen/deo-projects/deo-create-new-project/deo-create-new-project.component';
import { DeoDeleteProjectComponent } from './deo-ai-assistant-screen/deo-projects/deo-delete-project/deo-delete-project.component';
import { DeoProjectsComponent } from './deo-ai-assistant-screen/deo-projects/deo-projects.component';
import { DeoAiAssistFeedbackComponent } from 'app/shared/screens/deo-ai-assistant/deo-ai-assist-feedback/deo-ai-assist-feedback.component';
import { DeoArtifactsComponent } from './deo-ai-assistant-screen/deo-artifacts/deo-artifacts.component';
import { DeoAiAssistantWelcomeScreenComponent } from './deo-ai-assistant-screen/deo-ai-assistant-welcome-screen/deo-ai-assistant-welcome-screen.component';
import { DeoProjectFolderViewComponent } from './deo-ai-assistant-screen/deo-projects/deo-project-folder-view/deo-project-folder-view.component';
import { DeoAiAssistantExistingChatComponent } from './deo-ai-assistant-screen/deo-ai-assistant-existing-chat/deo-ai-assistant-existing-chat.component';
import { DeoAiRecentStarredChatSectionComponent } from './deo-ai-assistant-screen/deo-ai-recent-starred-chat-section/deo-ai-recent-starred-chat-section.component';
import { DeoViewArtifactDrawerComponent } from './deo-ai-assistant-screen/deo-artifacts/deo-view-artifact-drawer/deo-view-artifact-drawer.component';
import { DeoPanelStateComponent } from './deo-ai-assistant-screen/deo-panel-state/deo-panel-state.component';
import { DeoProjectInstructionsComponent } from './deo-ai-assistant-screen/deo-projects/deo-project-instructions/deo-project-instructions.component';

@NgModule({
  declarations: [
    DeoAiAssistantScreenComponent,
    DeoAiAssistantWidgetComponent,
    DeoTalkingToSelectorComponent,
    DeoAgentRunsPanelComponent,
    DeoConversationChipsComponent,
    DeoMessageProgressComponent,
    DeoAiAssistantChatsViewComponent,
    DeoAiAssistantRenameChatComponent,
    DeoAiAssistantMoveToProjectComponent,
    DeoAiAssistFeedbackComponent,
    DeoProjectsComponent,
    DeoCreateNewProjectComponent,
    DeoDeleteProjectComponent,
    DeoArtifactsComponent,
    DeoAiAssistantWelcomeScreenComponent,
    DeoProjectFolderViewComponent,
    DeoAiAssistantExistingChatComponent,
    DeoAiRecentStarredChatSectionComponent,
    DeoViewArtifactDrawerComponent,
    DeoPanelStateComponent,
    DeoProjectInstructionsComponent
  ],
  imports: [
    CommonModule,
    GainsUiCommonsModule,
    GainsSharedModule,
    FormsModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzInputModule,
    NzAvatarModule,
    NzTypographyModule,
    NzToolTipModule,
    NzTabsModule,
    NzDrawerModule,
    NzTagModule,
    NzRadioModule,
    NzPopoverModule,
    NzBadgeModule,
    RouterModule.forChild(routes),
    AngularSvgIconModule,

    NzUploadModule,
    NzDropDownModule,
    NzCheckboxModule
  ],
  exports: [
    DeoAiAssistantScreenComponent,
    DeoAiAssistantWidgetComponent,
    DeoAiAssistFeedbackComponent,
    DeoProjectsComponent,
    DeoCreateNewProjectComponent,
    DeoDeleteProjectComponent,
    DeoArtifactsComponent,
    DeoProjectFolderViewComponent,
    DeoAiAssistantExistingChatComponent,
    DeoAiAssistantChatsViewComponent,
    DeoViewArtifactDrawerComponent,
    DeoPanelStateComponent,
    DeoProjectInstructionsComponent
  ]
})
export class AiAgentModule {}
